/**
 * Parses a value as an absolute http(s) URL, or returns null.
 *
 * The single place the protocol allowlist lives. Everything that rewrites or
 * reads an outbound URL needs the same two answers — "can I parse this?" and "is
 * it http(s)?" — and each caller wants the parsed URL afterwards, so this returns
 * the object rather than a boolean.
 *
 * Null covers every reason a value is not usable: a relative path, a fragment, a
 * `mailto:`/`tel:`/`sms:`/`javascript:` scheme, or anything unparseable.
 */
export function httpUrl(value: string | null | undefined): URL | null {
  if (!value)
    return null

  try {
    const url = new URL(value)

    return ["http:", "https:"].includes(url.protocol) ? url : null
  }
  catch {
    return null
  }
}
